import { nextTick, ref } from 'vue'
import { recruitmentWebsiteApi } from '@/services/api'

/**
 * @deprecated use useInfinityRecruitmentWebsite instead
 */
export const useInfiniteRecruitmentWebsiteApi = ({ value = ref(), limit = ref(30), page = ref(0) }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    value.value = selected
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const websiteRequest = await recruitmentWebsiteApi.filter({ page: page.value, limit: limit.value, search: options.search }).promise
    loading.value = false
    list.value = options.new ? websiteRequest.docs : [...list.value, ...websiteRequest.docs]
    haveMore.value = websiteRequest.count?.currentPage < websiteRequest.count?.totalPages
    page.value++
  }

  const remove = (toRemove) => {
    value.value = undefined
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    loading,
    value,
  }
}

export const useInfinityRecruitmentWebsite = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]) }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true
      const searchRequest = recruitmentWebsiteApi.filter({ search: search.value, limit: limit.value, page: page.value })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage

      await nextTick()

      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

      return searchResponse
    }
    catch (err) {
      console.error('useInfinityRecruitmentWebsite', err)
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
